import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export function LoginPage() {
  const { access, signInWithPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (access === 'ok') return <Navigate to="/inbox" replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    const { error } = await signInWithPassword(email.trim(), password);
    if (error) setErr(error);
    setBusy(false);
  }

  return (
    <div className="center-screen">
      <form className="card narrow login-card" onSubmit={submit}>
        <div className="login-logo">🚨</div>
        <h1>Reality Alerts</h1>
        <p className="muted">Developer incident triage &amp; on-call alerting.</p>

        <label>Email</label>
        <input className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <label>Password</label>
        <input className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />

        {err && <div className="muted" style={{ color: '#e5484d', marginTop: 10 }}>{err}</div>}

        <button className="btn btn-primary btn-wide" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
    </div>
  );
}
